module.exports = __webpack_public_path__ + "static/media/gt.0b5663be.svg";